import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'table-datatable-string-with-action',
  templateUrl: './datatable-string-with-action.component.html',
  styleUrls: ['./datatable-string-with-action.component.scss'],
  imports: [MatButtonModule],
})
export class DatatableStringWithActionComponent {
  value = input<string | number>();
  key = input<string>();
  row = input<any>();

  cellActionClick = output<{ key: string; row: any }>();

  onClickAction() {
    this.cellActionClick.emit({ key: this.key(), row: this.row() });
  }
}
